import { Box, FlexLayout, GridLayout, H3, H4, Text } from '@deity/falcon-ui';
import Skeleton from '@material-ui/lab/Skeleton';
import { toLocalDateString } from 'contracts/constants';
import type { FC } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import type { GetPackageVersionQuery } from 'services/graphql/generated/operations';

type VersionStatusProps = {
  loading: boolean;
  packageVersionData: GetPackageVersionQuery | undefined;
};
const VersionStatus: FC<VersionStatusProps> = ({ packageVersionData, loading }) => {
  const { url } = useRouteMatch();
  const urlArr = url.split('/');
  urlArr.pop();
  urlArr.pop();

  return (
    <Box p="xxxl">
      <H3 fontWeight="bold" fontSize="xl" mb="xl">
        Version Status
      </H3>
      <GridLayout gridTemplateColumns="1fr 1fr" gridRowGap="xxl">
        <Box>
          <H4 fontWeight="bold" fontSize="md" mb="xs">
            Version Tag
          </H4>
          {loading ? (
            <Skeleton width="100%" height="23px" />
          ) : (
            <FlexLayout alignItems="center">
              <Text fontSize="lg" fontWeight="regular">
                {packageVersionData?.getPackageVersion.version}
              </Text>

              <Box ml="md" fontSize="lg" fontWeight="regular" color="primary">
                <Link to={`${urlArr.join('/')}/versions`} style={{ textDecoration: 'none' }}>
                  Version history
                </Link>
              </Box>
            </FlexLayout>
          )}
        </Box>
        <Box>
          <H4 fontWeight="bold" fontSize="md" mb="xs">
            Deployment Date
          </H4>
          <Text fontSize="lg" fontWeight="regular" color="secondary">
            {packageVersionData?.getPackageVersion?.deployedAt
              ? toLocalDateString(packageVersionData?.getPackageVersion.deployedAt)
              : 'Version has not been deployed yet.'}
          </Text>
        </Box>
        <Box>
          <H4 fontWeight="bold" fontSize="md" mb="xs">
            Last Modified
          </H4>
          {loading ? (
            <Skeleton width="100%" height="23px" />
          ) : (
            <Text fontSize="lg" fontWeight="regular">
              {packageVersionData ? toLocalDateString(packageVersionData?.getPackageVersion.modifiedAt) : ''}
            </Text>
          )}
        </Box>
        <Box>
          <H4 fontWeight="bold" fontSize="md" mb="xs">
            Version Created
          </H4>
          {loading ? (
            <Skeleton width="100%" height="23px" />
          ) : (
            <Text fontSize="lg" fontWeight="regular">
              {packageVersionData ? toLocalDateString(packageVersionData?.getPackageVersion.createdAt) : ''}
            </Text>
          )}
        </Box>
      </GridLayout>
    </Box>
  );
};

export default VersionStatus;
